// extracted by mini-css-extract-plugin
export default {"container":"yHHg0ZOAtB6nZ1Tl28OW","content":"D9vCk4Apm0lgQaSqlCGX"};